import axios from '@/plugins/axiosInstance'
import { settings } from '@/networking/urlManager'

/**
 * Fetches the category hierarchy for an asset
 * @param {string|number} assetId - The asset ID
 * @param {Object} options - Additional options
 * @returns {Promise<Object>} - The API response
 */
export const getCategoryHierarchy = async (assetId, options = {}) => {
  const { isActive = 1, isCustom = true, includePrompts = true } = options

  try {
    const response = await axios.get(settings.categoriesHierarchy, {
      params: {
        assetId,
        isActive,
        isCustom,
        includePrompts,
      },
    })
    return ({
      success: true,
      data: response?.data?.data || [],
      status: response.status,
    })
  } catch (error) {
    console.error('Error fetching category hierarchy:', error)
    throw error
  }
}
